import { Button, Col, Form, message, Row } from "antd";
import FileDownload from "js-file-download";
import React, { useEffect, useState } from "react";
import { useSocket } from "@components/SocketProvider";
import transmissionService from "@services/transmission.service";

let interval = undefined;

const HLD = () => {
  const socket = useSocket();
  const [submitted, setSubmitted] = useState(false);
  const [progress, setProgress] = useState(0);
  const [form] = Form.useForm();

  useEffect(() => {
    if (submitted) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(interval);
    }
  }, [submitted]);

  useEffect(() => {
    if (progress === 100) {
      setSubmitted(false);
      clearInterval(interval);
    }
    // eslint-disable-next-line
  }, [progress]);

  useEffect(() => {
    socket.on("progress", function (data) {
      // console.log("progress", data);
      setProgress(data);
    });

    socket.on("message", function (data) {
      // console.log("message", data);
      if (data.s === 0) {
        setSubmitted(false);
        message.error(data.message);
      }
    });
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    // setProgress(0);
    setSubmitted(true);

    try {
      const res = await transmissionService.Get("/hld_report", {
        ...values,
        io_id: socket.id,
      });

      const contentDisposition = res.headers["content-disposition"];
      const startIndex = contentDisposition.indexOf("filename=") + 10; // Adjust '+ 10' if filename is not the right one.
      const endIndex = contentDisposition.length - 1; //Check if '- 1' is necessary
      const filename = contentDisposition.substring(startIndex, endIndex);

      FileDownload(res.data, filename);
      setSubmitted(false);
    } catch (err) {
      console.log(err);
      setSubmitted(false);
    }
  };

  return (
    <div className="p-5 h-full img-bg img-bg-frequency">
      <div className="bg-white border border-gray-200 rounded-md p-5 flex-grow">
        <Form
          form={form}
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
        >
          <Row gutter={[14, 14]}>
            <Col xs={24} sm={24} md={12} lg={16} xl={18} xxl={20} className="flex items-center">
              <span>For downloading HLD Report, please click Download button.</span>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4} className="flex justify-end">
              {/* <Col span={24}> */}
              <Button
                type="primary"
                htmlType="submit"
                disabled={submitted}
              // className="mt-4"
              >
                Download
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default HLD;
